export const ASSETS = {
  schnauzerDog: "/schnauzer-dog.webp",
  schnauzerFull: "/schnauzer-full.png",
  logoTransparent: "/logo-wordmark.png",
  workKappa: "/work-kappa.webp",
  workMrac: "/work-mrac.webp",
  logoFull:
    "https://customer-assets.emergentagent.com/job_studio-silver/artifacts/ptdovueh_S3%20Logo%20-%20v2%20vertical%20ai%20StickerMule.webp",
  schnauzer: "/schnauzer.png",
  heroAbstract:
    "https://static.prod-images.emergentagent.com/jobs/33f40c49-28fd-49f5-aa0d-7d8670aa1f7e/images/4684fa3cf3da865960ee3797a776319e298e11a25af4a12ea9852335aee3227b.png",
  portApp:
    "https://static.prod-images.emergentagent.com/jobs/33f40c49-28fd-49f5-aa0d-7d8670aa1f7e/images/2c88aec8dc76b1e2c885d5b098e926a90c27bbb078e3f518f8a0c38c8eee9236.png",
  portBrand:
    "https://static.prod-images.emergentagent.com/jobs/33f40c49-28fd-49f5-aa0d-7d8670aa1f7e/images/139158f00ec39c84bc853952ebcd90c71b1ec225c76e495c49dcb410bf5283bd.png",
  portWeb:
    "https://static.prod-images.emergentagent.com/jobs/33f40c49-28fd-49f5-aa0d-7d8670aa1f7e/images/44d9f199d43c8f7b90e0b8fcaaed8abfa1b860f7bc1503604cf679348750ea90.png",
  portPoster: "/work-poster.webp",
};
